var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolicyDelays(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 17.5C2.87484 17.5 2.48248 17.3368 2.15609 17.0104C1.8297 16.684 1.6665 16.2917 1.6665 15.8333V4.16667C1.6665 3.70833 1.8297 3.31597 2.15609 2.98958C2.48248 2.66319 2.87484 2.5 3.33317 2.5H16.6665C17.1248 2.5 17.5172 2.66319 17.8436 2.98958C18.17 3.31597 18.3332 3.70833 18.3332 4.16667V15.8333C18.3332 16.2917 18.17 16.684 17.8436 17.0104C17.5172 17.3368 17.1248 17.5 16.6665 17.5H3.33317ZM3.33317 15.8333H16.6665V4.16667H3.33317V15.8333ZM4.1665 14.1667H8.33317V12.5H4.1665V14.1667ZM12.1248 12.5L16.2498 8.375L15.0623 7.1875L12.1248 10.1458L10.9373 8.95833L9.77067 10.1458L12.1248 12.5ZM4.1665 10.8333H8.33317V9.16667H4.1665V10.8333ZM4.1665 7.5H8.33317V5.83333H4.1665V7.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyDelays);
export default __webpack_public_path__ + "static/media/policy_delays.f17c11e4.svg";
export { ForwardRef as ReactComponent };